import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcToLocal',
  standalone: true,
})
export class UtcToLocalPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(
    value: string | Date | null,
    format: string = 'dd/MM/yyyy HH:mm:ss',
  ): string {
    if (!value) return '';

    const date = new Date(value);

    return this.datePipe.transform(date, format, '-0300') ?? '';
  }
}
